import { CustomPeriod } from "@admin/pages/shift-management/components";
import { getDateRange, Periods, Range } from "@enos-monorepo/lib";
import { useEffect, useState } from "react";
import { DateRange } from "react-day-picker";

interface DateRangeChangerProps {
  dateRange?: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
}
export function DateRangeChanger({
  dateRange,
  onDateRangeChange,
}: DateRangeChangerProps) {
  const [updatedDateRange, setUpdatedDateRange] = useState<
    DateRange | undefined
  >();
  const [customDateRange, setCustomDateRange] = useState<Range>();

  useEffect(() => {
    if (updatedDateRange) {
      onDateRangeChange(updatedDateRange);
      setUpdatedDateRange(undefined);
    }
  }, [updatedDateRange, onDateRangeChange]);

  const handleDateRangeChange = (range: Range) => {
    setCustomDateRange(range);
    onDateRangeChange({
      from: range.start,
      to: range.end,
    });
  };

  return (
    <div>
      <CustomPeriod
        includeToday={false}
        onSelectRange={handleDateRangeChange}
        selectedDateRange={
          !customDateRange
            ? getDateRange(Periods.ThisMonth, true)
            : dateRange?.from && dateRange?.to
              ? { start: dateRange.from, end: dateRange.to }
              : undefined
        }
        customSelectPanelAlign="right"
      />
    </div>
  );
}
